import { useProfileWidgetsExpandContext } from '../useProfileWidgetsExpandContext'

export function useIsProfileWidgetsExpandAvailable() {
  return useProfileWidgetsExpandContext() !== null
}
